"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import { useSeizeSettings } from "@/contexts/SeizeSettingsContext";
import { useMemo } from "react";
export const useMemesQuickVoteContext = () => {
  const $ = _c(8);
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const {
    seizeSettings,
    isLoaded
  } = useSeizeSettings();
  connectedProfile?.handle;
  let t0;
  if ($[0] !== connectedProfile?.handle) {
    t0 = connectedProfile?.handle?.trim();
    $[0] = connectedProfile?.handle;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const normalizedHandle = t0;
  const contextProfile = normalizedHandle ?? null;
  const memesWaveId = seizeSettings.memes_wave_id ?? null;
  const isEnabled = isLoaded && typeof memesWaveId === "string" && memesWaveId.length > 0 && typeof contextProfile === "string" && contextProfile.length > 0 && activeProfileProxy === null;
  const t1 = activeProfileProxy?.id ?? null;
  let t2;
  if ($[2] !== contextProfile || $[3] !== isEnabled || $[4] !== isLoaded || $[5] !== memesWaveId || $[6] !== t1) {
    t2 = {
      contextProfile,
      isEnabled,
      isLoaded,
      memesWaveId,
      proxyId: t1
    };
    $[2] = contextProfile;
    $[3] = isEnabled;
    $[4] = isLoaded;
    $[5] = memesWaveId;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};